// icons.ts
import playIcon   from './musicIcons/play.png';
import pauseIcon  from './musicIcons/pause.png';
import nextIcon   from './musicIcons/next.png';
import prevIcon   from './musicIcons/prev.png';

export const icons = { playIcon, pauseIcon, nextIcon, prevIcon };
